module.exports = "<div class=\"vc-backtop-component\">\n        <a href=\"javascript:\" v-el:btn class=\"iconfont icon-top\" :style=\"style\" @click=\"backTop\" v-show=\"show\">\n            <i :style=\"{width: iconWidth, height: iconHeight}\"></i>\n        </a>\n    </div>";


//////////////////
// WEBPACK FOOTER
// ../~/.1.2.3@vue-html-loader!../~/.7.1.7@vue-loader/lib/selector.js?type=template&index=0!./src/Backtop.vue
// module id = 6
// module chunks = 0